var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.220703,
    width: 24.9714,
    height: 25,
    fill: "url(#pattern0_907_5827)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_907_5827",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_907_5827",
    transform: "matrix(0.0333333 0 0 0.0332952 0 0.000572052)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_907_5827",
    width: 30,
    height: 30,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAAAsTAAALEwEAmpwYAAABL0lEQVR4nO2WwUrDQBCGI3QnoHhU+gIiCJnJA+hRsfWN7EHQmYC+S5/BgweVHgSLeK/tuS9QqUwImpJNCWk29rA/DOxmN/NlZifsBIGXl2tBnPQN8ReQLF2YUd8R9wpgl9A/uEyKEWeLzjJKJf49eLtSfXy/DyTPajq27onlAFBGQPLUEHi5Y4iHud9jqM/yO/bw5hCIx+kelFEjYCAeZA7nqek4kmsrlHis843BISUXgLwAkm8gvgpjOc/P0/SSvGeZ+Nw9eehW9g8lCxDfHv1GSDywZcAgf5RFWh+M8mY/09UzXwetBTYoj0D8Yq1irXKUVy2kddBa4KYEHvzvqTbIs6r3agfvTvPvdiI5q3Qfo0wLX9K2BW10HoXItRPRPqhNuCGZhJhcuqolr+3RD+TN2t1C70r0AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeoIcon);
export default __webpack_public_path__ + "static/media/seo-icon.aa3c676c9b269485c31c68672519d503.svg";
export { ForwardRef as ReactComponent };